import { retrieve, update } from "framework/http/endpoint";
import { createCollectionResponseFactory, createEntityResponseFactory } from "framework/http/rest/jsonResponse";
import { fromApiTransportDate, fromApiTransportDateTimeOffset } from "framework/http/transport";
import { getIsoStringDate } from "framework/helpers";
import { UrlPathOfApiLocation } from "common/paths";
var ApiUriPrefix = "".concat(UrlPathOfApiLocation, "/api/1/");
var CompetitionsApiUri = ApiUriPrefix + "competitions";
var CompetitionEventsApiUri = ApiUriPrefix + "competition_events";
function apiGetCompetitionEvents(fromDate, toDate) {
    if (fromDate === void 0) { fromDate = null; }
    if (toDate === void 0) { toDate = null; }
    var params = {};
    if (fromDate != null) {
        params.from = getIsoStringDate(fromDate);
    }
    if (toDate != null) {
        params.to = getIsoStringDate(toDate);
    }
    ;
    var queryParams = Object.entries(params).map(function (e) { return "".concat(e[0], "=").concat(e[1]); }).reduce(function (pv, cv, idx) {
        return pv + (idx == 0 ? "?" : "&") + cv;
    }, "");
    var uri = CompetitionEventsApiUri + queryParams;
    return retrieve(uri, null, createCollectionResponseFactory(fromTransportEventInfo));
}
function apiGetCompetitionEvent(eventId) {
    var uri = "".concat(CompetitionEventsApiUri, "/").concat(eventId.toString());
    return retrieve(uri, null, createEntityResponseFactory(fromTransportEvent));
}
function apiGetCompetition(competitionId) {
    var uri = "".concat(CompetitionsApiUri, "/").concat(competitionId.toString());
    return retrieve(uri, null, createEntityResponseFactory(fromTransportCompetition));
}
function apiGetCompetitionResult(competitionId) {
    var uri = "".concat(CompetitionsApiUri, "/").concat(competitionId, "/result");
    return retrieve(uri, null, createEntityResponseFactory(fromTransportCompetitionResult));
}
function fromTransportEventInfo(entity) {
    entity.dateFrom = fromApiTransportDate(entity.dateFrom);
    entity.dateTo = fromApiTransportDate(entity.dateTo);
    return entity;
}
function fromTransportEvent(entity) {
    entity.dateFrom = fromApiTransportDate(entity.dateFrom);
    entity.dateTo = fromApiTransportDate(entity.dateTo);
    return entity;
}
function fromTransportCompetitionResult(entity) {
    entity.completedAt = fromApiTransportDateTimeOffset(entity.completedAt);
    return entity;
}
function fromTransportCompetition(entity) {
    entity.date = fromApiTransportDateTimeOffset(entity.date);
    return entity;
}
function apiPutApproveInvigilatorReport(eventId) {
    var uri = "".concat(CompetitionEventsApiUri, "/").concat(eventId.toString(), "/report/publish");
    return update(uri, null);
}
function apiPutDisapproveInvigilatorReport(eventId) {
    var uri = "".concat(CompetitionEventsApiUri, "/").concat(eventId.toString(), "/report/hide");
    return update(uri, null);
}
export { apiGetCompetition, apiGetCompetitionEvents, apiGetCompetitionEvent, apiGetCompetitionResult, apiPutApproveInvigilatorReport, apiPutDisapproveInvigilatorReport, };
